import { Cell, Row } from '@silevis/reactgrid';
import { produce } from 'immer';

export const makeCellsNonEditable = <T extends Row<Cell>>(rows: T[]): T[] =>
  produce(rows, (rows) => {
    rows.forEach((row) => {
      row.cells.forEach((cell) => (cell.nonEditable = true));
    });
  });
